// Footer columns — Jacquemus-style global toggle.
//
// Clicking ANY column header (Shop / Company / Support) toggles a single
// `.is-expanded` class on the `.sentiments-footer__cols` root. All three
// columns expand / collapse together — there's no per-column state.
//
// Every column header is a <button aria-expanded="…">. We keep all three
// buttons' aria-expanded values in lockstep with the root's class so
// screen readers announce the correct state regardless of which button
// the user activated.
//
// Follow column has no header button (always-visible inline socials),
// so it's not part of the toggle set.

export function initFooterAccordion() {
	const root = document.querySelector('.sentiments-footer__cols');
	if (!root) return;

	const titles = root.querySelectorAll(
		'.sentiments-footer__col[data-collapsible="true"] .sentiments-footer__col-title'
	);
	if (!titles.length) return;

	const toggle = () => {
		const willOpen = !root.classList.contains('is-expanded');
		root.classList.toggle('is-expanded', willOpen);
		titles.forEach((t) => t.setAttribute('aria-expanded', String(willOpen)));
	};

	titles.forEach((t) => t.addEventListener('click', toggle));
}
